import styled from "styled-components";

export const Wrapper = styled.div`
    height:${({ height }) => (height || "600")}px!important;
    & .app-map{
        height:100% !important;
    }
`;